import type { Entity } from '@models/Entity'

import { apiClient } from '../../../gateways/api'
import type { Activiteit } from '../types/Activiteit'

export { cancelActiviteitForEntity }

const cancelActiviteitForEntity = async ({
  entity: { type, id },
  activiteitInfo: { _id, text },
}: {
  entity: Entity
  activiteitInfo: Pick<Activiteit, '_id' | 'text'>
}) => {
  const url = `/rest/${type}/${id}/activiteit/${_id}`

  await apiClient({
    url,
    method: 'PATCH',
    data: { status: 'cancelled', text },
  })
}
